import React, { useState, useEffect } from 'react';
import '../styles/SyncStatus.css';

function SyncStatus({ token }) {
  const [logs, setLogs] = useState([]);
  const [feeds, setFeeds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSyncStatus();
    // Refresh every 30 seconds
    const interval = setInterval(loadSyncStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadSyncStatus = async () => {
    try {
      const response = await fetch('/api/dashboard/sync-status', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const data = await response.json();
        setLogs(data.logs);
        setFeeds(data.feeds);
      }
    } catch (err) {
      console.error('Sync status fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const getStatusBadgeClass = (status) => {
    return `status-badge status-${status}`;
  };

  if (loading) {
    return <div className="sync-status-loading">Loading sync status...</div>;
  }

  return (
    <div className="sync-status">
      <div className="sync-feeds">
        <h3>Feed Status</h3>
        {feeds.length === 0 ? (
          <p className="no-data">No feeds configured. Add iCal URLs in Settings.</p>
        ) : (
          <div className="feeds-list">
            {feeds.map(feed => (
              <div key={feed.id} className="feed-card">
                <div className="feed-header">
                  <h4>{feed.name}</h4>
                  <span className={`feed-status ${feed.isActive ? 'active' : 'inactive'}`}>
                    {feed.isActive ? '✓ Active' : '○ Inactive'}
                  </span>
                </div>
                <div className="feed-details">
                  {feed.lastSynced ? (
                    <p>Last synced: {formatDate(feed.lastSynced)}</p>
                  ) : (
                    <p className="no-sync">Never synced</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="sync-logs">
        <h3>Sync History</h3>
        {logs.length === 0 ? (
          <p className="no-data">No sync logs yet.</p>
        ) : (
          <div className="logs-list">
            {logs.slice(0, 10).map(log => (
              <div key={log.id} className="log-entry">
                <div className="log-header">
                  <span className={getStatusBadgeClass(log.status)}>
                    {log.status.toUpperCase()}
                  </span>
                  <span className="log-time">{formatDate(log.syncTime)}</span>
                </div>
                <div className="log-details">
                  {log.status === 'success' && (
                    <p>{log.message} (Events: {log.eventsSynced || 0})</p>
                  )}
                  {log.status === 'error' && (
                    <p className="error-text">{log.errorMessage}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SyncStatus;
